import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/warehouses/:warehouseId/scrap-units`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const scrapUnits = {
  post: apiPathFunc(pathBase),
};
